import React, {useState, useEffect} from 'react'
import { FormGroup, Label, FormFeedback } from 'reactstrap'
import { useField, useFormikContext } from 'formik'
import cn from 'classnames'
import ReactDatePicker, { registerLocale } from 'react-datepicker'
import es from 'date-fns/locale/es'
import 'react-datepicker/dist/react-datepicker.css'
import styled from 'styled-components'
import moment from 'moment'

const DatePickerWrapper = styled.div`
  .react-datepicker-wrapper {
    display: block;
  }
`

const DatePicker = ({label, ...props }) => {
  const {machine} = props
  const [current] = machine
  const {event, tickets} = current.context

  // TODO: Configurar en product confgi también

  const releaseDate = () => {
    let vehicleRelease = null

    if (tickets.some((t) => ['44', '45'].includes(t.id) && t.qty > 0)) {
      vehicleRelease = props.params.slow_release || 8
    }

    const releaseDate = moment()
    const remainder = 5 - (releaseDate.minute() % 5)
    releaseDate.add(vehicleRelease || props.params.release || 7, 'hours').add(remainder, 'minutes').set('second', 0)

    const closeTime = props.params.close_time
    const openTime = props.params.open_time

    if (!closeTime || !openTime) {
      return releaseDate
    }

    const closeDate = moment()
    closeDate.hour(closeTime.split(':')[0])
    closeDate.minutes(closeTime.split(':')[1])

    const openDate = moment()
    // openDate.add(1, 'day')
    openDate.hour(openTime.split(':')[0])
    openDate.minutes(openTime.split(':')[1])

    const now = moment()

    if (now < openDate) {
      return openDate
    } else if (now > closeDate) {
      return openDate.add(1, 'day')
    } else {
      return releaseDate
    }
  }

  const name = (props.field && props.field.name) || props.name
  const [field, meta] = useField(name)
  const {setFieldValue} = useFormikContext()
  const [selected, setSelected] = useState(releaseDate().toDate())

  useEffect(() => setSelected(releaseDate().toDate()), [tickets])

  const filterPassedTime = (time) => {
    let selectedCopy = new Date(selected.valueOf())
    selectedCopy.setHours(time.getHours(), time.getMinutes(), time.getSeconds())

    return releaseDate().toDate() < selectedCopy
  }

  useEffect(() => {
    registerLocale('es', es)
  }, [])

  useEffect(() => {
    setFieldValue(field.name, moment.tz(moment(selected).format('YYYY-MM-DD HH:mm'), event.local_timezone).format())
  }, [selected])

  return (
    <FormGroup>
      <DatePickerWrapper>
        <Label className='control-label' htmlFor={props.id || props.name}>
          {label}
          {props.required &&
            <span className="text-danger ms-1">*</span>
          }
        </Label>
        <ReactDatePicker
          className={
            cn([
              'form-control',
              meta.touched && meta.error ? 'is-invalid' : '',
              meta.touched && !meta.error ? 'is-valid' : ''
            ])
          }
          locale="es"
          selected={ selected }
          onChange={(date) => setSelected(date)}
          dateFormat="P"
          timeIntervals={5}
          filterTime={filterPassedTime}
          minDate={releaseDate()}
          autoComplete={false}
          onKeyDown={(e) => {
              e.preventDefault();
          }}
          {...props}
          excludeDates={props.params && props.params.disabled_days && props.params.disabled_days.map((day) => moment(day).toDate())}
        />
      </DatePickerWrapper>

      {meta.touched && meta.error ? (
        <FormFeedback style={{display: 'block'}} className={'help-block'}>{meta.error}</FormFeedback>
      ) : null}
    </FormGroup>
  )
}

export default DatePicker
